export default __webpack_public_path__ + "static/media/menu-arrow.5fd47716.svg";